import ContentLayoutDetailsHeader from "../../../Common/ContentLayoutDetailsHeader";
import React, { useEffect, useState, useRef } from "react";
import ReactPlayer from "react-player";
import "../videoPlayer/videoPlayer.scss";
import userService from "../../../services/user.service";
import AllEvents from "./AllEvents";
import { useHistory } from "react-router-dom";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { getFromLocalStorage } from "../../../utils/webStorage";
import "bootstrap/dist/css/bootstrap.min.css";
import SchoolAdminDashboard from "../schoolAdminDashboard";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { resetVideoLibraryInitialState } from "../../../Redux/Actions/VideoLibraryActions";
import VideoSelection from "./VideoSelection";
import TextBox from "./TextBox";
import NameDialog from "../Popups/NameDialog";
import WarningDialog from "../Popups/WarningDialog";
import { openFailDialog } from "../../../Redux/Actions/PopupActions";
import handleAddTheme from "./services/handleAddTheme";
import {
  setProgressBar,
  setFinishedEdit,
  setOpenNameDialog,
  updatePlaylistMedia,
  setSelectedVideoPath,
  setPlaylistData,
} from "../../../Redux/Actions/VideoHighlightAction";
import Theme from "./Theme";
import Toolkit from "./Toolkit";
import ThemeDialog from "./ThemeDialog";
import ToolkitSecond from "./ToolkitSecond";
import handleAllVideoEdit from "./services/handleAllVideoEdit";
import ProgressBar from "./ProgressBarForEdit";

const VideoHighlight = () => {
  const schoolId = getFromLocalStorage("schoolId");
  const [mediaBreakdownColumn, setMediaBreakdownColumn] = useState([]);
  const [videoFullWidth, setVideoFullWidth] = useState(true);
  const [videoPath, setVideoPath] = useState("");
  const [eventID, setEventID] = useState();
  const [playing, setPlaying] = useState(true);
  const [isPaymentOverdue, setIsPaymentOverdue] = useState(false);
  const [playlistSelected, setPlaylistSelected] = useState(false);
  const [playbackHandleValue, setPlaybackHandleValue] = useState(0);
  const [maxDuration, setMaxDuration] = useState(0);
  const [isWarningDialog, setIsWarningDialog] = useState(false);
  const [isMerge, setIsMerge] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const videoRef = useRef(null);
  const [filled, setFilled] = useState(0);
  const {
    selectedVideoPaths,
    editedVideoName,
    showToolkit,
    showToolkitSecond,
    videoPathForTrim,
    isOverlayText,
    showSlider,
    themeImageUrlSend,
    editedVideoPosition,
    isProgressBar,
  } = useSelector((state) => state?.videoHighlightData);
  useEffect(() => {
    userService.getBillingDetailsCheck(schoolId).then((res) => {
      const check = res.data.status;
      setIsPaymentOverdue(check);
    });
    userService.getDefaultBreakdownToBreakdown(schoolId);
    return () => {
      resetVideoLibraryInitialState(dispatch, {});
      setSelectedVideoPath(dispatch, []);
    };
  }, []);
  const { isDrawerOpen } = useSelector(
    (state) => state?.schoolAdminDashboardInformation
  );

  const playEditedVideo = (videoPath, id) => {
    if (id != eventID) {
      setEventID(id);
      setVideoPath(videoPath);
      setPlaying(true);
      return;
    }
    setVideoPath(videoPath);
    setPlaying(!playing);
    setEventID(id);
  };

  const playVideo = (videoPath, id) => {
    setPlaying(true);
  };

  const isPlaylistSelected = () => {
    setPlaylistSelected(true);
  };

  const intercutPlaylist = (
    seasonName,
    seasonType,
    eventType,
    eventName,
    practiceName,
    opponentName
  ) => {
    switch (seasonType) {
      case "In-Season":
        history.push(
          `/intercutvideo?season-year=${seasonName}&season-type=${seasonType}&event-type=${eventType}&week=${opponentName}`
        );
        break;

      case "Off-Season":
        history.push(
          `/intercutvideo?season-year=${seasonName}&season-type=${seasonType}&event=${eventName}&practice=${practiceName}`
        );
        break;

      case "Other":
        history.push(
          `/intercutvideo?season-year=${seasonName}&season-type=${seasonType}&event=${eventName}`
        );
        break;

      default:
        break;
    }
  };

  const handleProgress = (progress) => {
    setPlaybackHandleValue(progress.playedSeconds);
  };
  //working
  const merge = async () => {
    let response;
    setOpenNameDialog(dispatch, false);
    setProgressBar(dispatch, true);
    try {
      response = await handleAllVideoEdit(selectedVideoPaths, editedVideoName);
      if (themeImageUrlSend) {
        response = await handleAddTheme(
          editedVideoName,
          themeImageUrlSend,
          response.data.filePath
        );
      }

      if (response.success) {
        let responseForSave;
        const mediaFiles = [
          {
            ...response.data,
          },
        ];
        const {
          eventType,
          schoolId,
          eventName,
          practiceName,
          seasonType,
          scheduleId,
          isPractice,
          seasonId,
          playListId,
        } = videoPathForTrim;
        if (editedVideoPosition === "add") {
          responseForSave = await userService.saveScheduleEventForVideoEditing(
            eventType,
            schoolId,
            eventName,
            practiceName,
            mediaFiles,
            seasonType,
            scheduleId,
            isPractice,
            seasonId,
            true,
            playListId,
            false
          );
        } else if (editedVideoPosition === "replace") {
          const { filePath, videoDuration, fileSize, fileName } = response.data;
          responseForSave = await userService.updateMediaVideoUrl(
            videoPathForTrim.id,
            filePath,
            videoDuration,
            fileSize,
            fileName
          );
        }
        updatePlaylistMedia(dispatch, {
          newMedia: responseForSave.data.data[0],
          playlistId: playListId,
        });
      }
      setFinishedEdit(dispatch, true);
    } catch (error) {
      setFilled(0);
      setFinishedEdit(dispatch, false);
      setProgressBar(dispatch, false);
      openFailDialog(dispatch, {
        open: true,
        message: "Something went wrong!",
      });
    }
  };

  const handlePlay = () => {
    setPlaying(true);
  };
  const handlePause = () => {
    setPlaying(false);
  };

  return (
    <div
      className={
        isDrawerOpen
          ? "content-layout add-sectionn p-0 position-relative"
          : "toggle-content-layout add-sectionn p-0 position-relative"
      }
    >
      <SchoolAdminDashboard />
      <ContentLayoutDetailsHeader
        label="Video Highlight"
        name="Create Highlight"
        navigationLink="/schooladmindata"
        iconList={[]}
      />
      {isProgressBar && <ProgressBar filled={filled} setFilled={setFilled} />}
      <NameDialog merge={merge} />
      <ThemeDialog />
      <WarningDialog
        setIsWarningDialog={setIsWarningDialog}
        isWarningDialog={isWarningDialog}
      />
      <div className="videoPlayer-container pd-15">
        {showSlider && <Theme />}
        <div className="videoPlayer">
          <div className="centerHighlight">
            <div className="centerLeft">
              {videoPath ? (
                <ReactPlayer
                  id="videoPlayer"
                  url={videoPath}
                  playing={playing}
                  onEnded={() => setPlaying(false)}
                  onPause={handlePause}
                  onPlay={handlePlay}
                  onProgress={handleProgress}
                  ref={videoRef}
                  controls
                  className="videoPlayer"
                />
              ) : (
                <span>No video selected</span>
              )}
              <div
                className="videoToggle"
                onClick={() => setVideoFullWidth(!videoFullWidth)}
              >
                {videoFullWidth ? <ChevronRightIcon /> : <ChevronLeftIcon />}
              </div>
              {isOverlayText && <TextBox />}
              {showToolkit && <Toolkit />}
              {showToolkitSecond && <ToolkitSecond />}
            </div>
            <div
              className={`${
                videoFullWidth
                  ? "centerRight"
                  : "centerRight centerRightHidden centerRightHeight"
              }`}
            >
              <AllEvents
                playSelectedVideo={playEditedVideo}
                playVideo={playVideo}
                isPlaylistSelected={isPlaylistSelected}
                allVideos={mediaBreakdownColumn}
                intercutPlaylist={intercutPlaylist}
                setVideoPath={setVideoPath}
                videoPath={videoPath}
              />
            </div>
          </div>
          <VideoSelection
            setVideoPath={setVideoPath}
            videoPath={videoPath}
            videoRef={videoRef}
            playbackHandleValue={playbackHandleValue}
            setPlaybackHandleValue={setPlaybackHandleValue}
            maxDuration={maxDuration}
            setMaxDuration={setMaxDuration}
            setIsMerge={setIsMerge}
          />
        </div>
        {isPaymentOverdue == true ? (
          <div>
            <div className="payment-overdue-msg-box"></div>
            <div>
              <h2 className="disabledMessage bold">Your Payment is overdue</h2>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default VideoHighlight;
